module.exports = __webpack_public_path__ + "static/media/12-5.e699ed5e.mp3";